import { useTranslation } from 'react-i18next';

const FamilyBuildingSurrogacySources = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="surrogacy-journey-label">Surrogacy Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Will donor egg or sperm be part of your journey?</h3>
        
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyDonor"
            id="surrogacyDonor1"
            value="Yes"
            checked={formData.SurrogacyDonor === "Yes"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyDonor1" className="multistep-form-radio-checkbox-label">Yes</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyDonor"
            id="surrogacyDonor2"
            value="No"
            checked={formData.SurrogacyDonor === "No"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyDonor2" className="multistep-form-radio-checkbox-label">No</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyDonor"
            id="surrogacyDonor3"
            value="Not sure"
            checked={formData.SurrogacyDonor === "Not sure"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyDonor3" className="multistep-form-radio-checkbox-label">Not sure</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
    {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingSurrogacySources;
